interface ContactNotesCardProps {
  lunchNotes: string
  /** 表示用（例: priorContactVisitPlanLabel の結果または「—」） */
  priorContactVisitPlanDisplay?: string
  /** 表示用（例: displayValue の結果） */
  priorContactVisitScheduleDisplay?: string
}

function ContactNotesCard({
  lunchNotes,
  priorContactVisitPlanDisplay = '—',
  priorContactVisitScheduleDisplay = '—',
}: ContactNotesCardProps) {
  const fields = [
    { label: '事前連絡・訪問の実施予定', value: priorContactVisitPlanDisplay },
    { label: '事前連絡・訪問の実施予定日', value: priorContactVisitScheduleDisplay },
    { label: '昼食についての連絡事項', value: lunchNotes },
  ]

  return (
    <div className="town-info-card">
      <h3 className="town-info-card__title">連絡事項</h3>
      {fields.map(({ label, value }, i) => (
        <div
          key={label}
          className={`town-detail-field ${i === fields.length - 1 ? 'is-last' : ''}`}
        >
          <div className="town-detail-field__label">{label}</div>
          <div className="town-detail-field__value">{value}</div>
        </div>
      ))}
    </div>
  )
}

export default ContactNotesCard
